import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map } from 'rxjs/operators';

import { CmsService } from '../services/cms/cms.service';
import { IOddsBoostConfig } from '../services/cms/models/odds-boost-config.model';

export const OddsBoostGuard: CanActivateFn = () => {
    const router = inject(Router);
    return inject(CmsService)
        .getOddsBoost()
        .pipe(
            map((config: IOddsBoostConfig) => {
                if (!config.enabled) {
                    router.navigateByUrl('/');
                    return false;
                }
                return true;
            }),
        );
};
